"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _class, _descriptor, _descriptor2, _temp;

var Points = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Points, _Component);

  function Points() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, Points);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Points)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "rule", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(Points, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_base.default, {
        type: "points"
      }, _react.default.createElement("div", {
        className: "icon",
        style: {
          backgroundImage: this.item.icon_name ? "url(".concat(this.item.icon_name, ")") : void 0
        }
      }), _react.default.createElement("h2", {
        className: "name"
      }, this.rule.rewardCount, " ", this.item.unitName), _react.default.createElement("h2", {
        className: "count"
      }, this.item.name));
    }
  }]);
  return Points;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "rule", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = Points;